import { HttpErrorResponse } from '@angular/common/http';
import { Injectable } from '@angular/core';

type DpSupportedErrors = HttpErrorResponse | string;

type DpErrorHandler = (error: DpSupportedErrors) => string;

@Injectable({ providedIn: 'root' })
export class DpErrorService {
  private readonly ERROR_MAP = new Map<DpSupportedErrors, DpErrorHandler>().set(
    typeof HttpErrorResponse,
    (error: unknown): string => (error as HttpErrorResponse).message
  );

  handle(error: DpSupportedErrors): Error {
    const errorType = typeof error;
    const handler = this.ERROR_MAP.get(errorType);

    if (handler) {
      return new Error(handler(error));
    }

    return new Error('Unknown error');
  }
}
